import React, { useState } from 'react';
import {
  CustomTextField,
  CustomTextFieldWithoutAsterisk,
} from '../FormFields/GeneralFormFields';
import { format } from 'date-fns';
import { Form, Formik } from 'formik';
import { Button, Column } from '@codeparva/ui-components-library';
import { achPaymentFormSchema } from '../../formValidationSchema';
import { FontAwesomeIcon } from '../../../../utilities/iconLoader/FontAwesomeIcon';
import { getPaymentRequest } from '../../helpers/PaymentHelpers';
import { encryptWithPublicKey } from '@codeparva/v11-tfw-api-library';
import { maskCharacters } from '../../../../utilities/utils';

export const ACHFormModal = ({
  shouldShowAchForm,
  setShouldShowAchForm,
  getPaymentAmount,
  autoPayStatues,
  amountWithoutModifier,
  individualUnitData,
  paymentMethod,
  paymentType,
  savingForFutureTransaction,
  surchargeOrDiscount,
  removeMoveInReserveCookie,
  callBackHandler,
  configs,
  setMoveInReserveCookie,
  setHasError,
  setDisabled,
  publicKey,
}: any) => {
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const ModalHeader = () => {
    return (
      <header className="modal-card-head">
        <p className="modal-card-title">ACH Payment Details</p>
        <button
          className="closeButton"
          onClick={() => {
            setShouldShowAchForm(!shouldShowAchForm);
            setDisabled(false);
          }}
          aria-label="close"
          disabled={isButtonLoading}
        >
          {' '}
          <FontAwesomeIcon
            iconClassName={'IoClose'}
            style={{
              fontSize: 36,
            }}
          />
        </button>
      </header>
    );
  };

  return (
    <>
      {shouldShowAchForm && (
        <div
          className={`modal achFormModal ${shouldShowAchForm && 'is-active'}`}
        >
          <div className="modal-background"></div>
          <div className="modal-card">
            <ModalHeader />
            <section className="modal-card-body">
              <Formik
                initialValues={{
                  routingNumber: '',
                  accountNumber: '',
                  bankName: '',
                }}
                validationSchema={achPaymentFormSchema}
                onSubmit={async (values: any) => {
                  setIsButtonLoading(true);
                  setDisabled(true);
                  const { bankName, routingNumber, accountNumber } = values;
                  const todaysDate = format(new Date(), 'yyyy-MM-dd');
                  const displayAccountNumber = maskCharacters(accountNumber);
                  const encryptedAccountNumber = await encryptWithPublicKey(
                    accountNumber,
                    publicKey,
                    true
                  );
                  let requestBody = {};

                  try {
                    requestBody = getPaymentRequest(
                      getPaymentAmount(),
                      autoPayStatues,
                      amountWithoutModifier,
                      individualUnitData || {},
                      paymentMethod,
                      paymentType,
                      savingForFutureTransaction,
                      surchargeOrDiscount,
                      todaysDate,
                      {},
                      {
                        bankName,
                        routingNumber,
                        displayAccountNumber,
                        encryptedAccountNumber,
                      }
                    );
                  } catch (e) {
                    console.error(e);
                  }

                  try {
                    removeMoveInReserveCookie();
                    await callBackHandler(requestBody, configs);
                  } catch (e) {
                    setMoveInReserveCookie();
                    console.error('Error from new card section', e);
                    setHasError(true);
                    setDisabled(false);
                  }
                  setIsButtonLoading(false);
                }}
              >
                {({ handleSubmit, dirty, isValid }) => (
                  <div className="achPaymentForm">
                    <div className="achInfoContainer">
                      <Form
                        method="post"
                        autoComplete="off"
                        onSubmit={handleSubmit}
                      >
                        <div className="achFieldsSection">
                          <Column size={'two-thirds'}>
                            <CustomTextField
                              label="Routing Number"
                              type="text"
                              name="routingNumber"
                              placeholder="Enter Routing Number"
                            />
                          </Column>
                          <Column size={'two-thirds'}>
                            <CustomTextField
                              label="Account Number"
                              type="text"
                              name="accountNumber"
                              placeholder="Enter Account Number"
                            />
                          </Column>
                          <Column size={'two-thirds'}>
                            <CustomTextFieldWithoutAsterisk
                              label="Bank Name"
                              type="text"
                              name="bankName"
                              placeholder="Enter Bank Name"
                            />
                          </Column>

                          <Column size={'two-thirds'} className="btnContainer">
                            <Button
                              id="payment-button"
                              className={`cp-primary-button-highlighted ${
                                isButtonLoading ? 'is-loading' : ''
                              }`}
                              type="button"
                              disabled={!dirty || !isValid || isButtonLoading}
                              onClick={(e: any) => {
                                handleSubmit(e);
                              }}
                            >
                              Pay
                            </Button>
                          </Column>
                        </div>
                      </Form>
                    </div>
                  </div>
                )}
              </Formik>
            </section>
          </div>
        </div>
      )}
    </>
  );
};
